// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__9G60x","emails":"CreateEditClinics_emails__1h2HO","emailTagLabel":"CreateEditClinics_emailTagLabel__3E19P"};